import createStore from "redux-zero";

const initialState = {
  products: {},
  reviews: {},
  user_likes: [],
  user_dislikes: [],
};
const store = createStore(initialState);

export default store;
